import styled from '@emotion/styled';

export const AccordionContainer = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	gap: 2rem;

	.accordion-content-container {
		display: flex;
		flex-wrap: wrap;
		width: 100%;
	}
`;

export const Divider = styled.div`
	border-bottom: 1px solid var(--border-color);
	margin: 3rem 0;
	width: 100%;
`;
